import HorizontalField from './HorizontalField';

export default HorizontalField;
